import Ticker from "react-ticker";
import styles from "./index.module.less";

import type { NotificationMessage } from "../../../shared/interface/dashboard.interface";

const NewsSlider = (props: { list: NotificationMessage[]; loading: boolean }) => {
  const { list, loading } = props;

  return (
    <div className={styles["news-ticker-container"]}>
      {loading ? (
        <span>Loading...</span>
      ) : list?.length ? (
        <Ticker offset="run-in" mode="await">
          {() => (
            <div className={styles["news-ticker"]}>
              {list.map((item, index) => (
                <div key={index} className={styles[item.isToday ? "todays-notify" : "future-notify"]}>
                  &#x2022; {item.notification_message ?? ""}
                </div>
              ))}
            </div>
          )}
        </Ticker>
      ) : null}
    </div>
  );
};

export default NewsSlider;
